import { defer, type LoaderFunctionArgs } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getLimitPage } from "../common/service";
import { USE_MOCK, MOCK_PAGE_INFO } from "./page/mock";

// TODO: 联调期 mock，看完页面改回真实请求（删掉 mock 分支，恢复 getLimitPage({ type })）
export function limitSetLoader({ request }: LoaderFunctionArgs) {
  const type = new URL(request.url).searchParams.get("type") || "";
  return defer({
    coreData: resolveLoaderResult(
      USE_MOCK ? Promise.resolve(MOCK_PAGE_INFO) : getLimitPage({ type })
    ),
  });
}
